import { Disclosure } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { Link, useLocation } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { ArrowLeftOnRectangleIcon } from "@heroicons/react/20/solid";
import * as ROUTES from "../../constants/routes";

const Navigation = () => {
  const location = useLocation();

  const { logout } = useAuth();
  const onLogoutClick = () => {
    try {
      logout();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Disclosure as="nav" className="bg-white shadow">
      {({ open }) => (
        <>
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="flex h-16 justify-between">
              <div className="flex">
                <div className="flex flex-shrink-0 items-center">
                  <img
                    className="h-16 w-auto"
                    src="logo_lg.png"
                    alt="TTM logo"
                  />
                </div>
              </div>
              <div className="hidden md:ml-6 md:flex md:space-x-8">
                {/* Current: "border-indigo-500 text-gray-900", Default: "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700" */}
                {/*  border-indigo-500 text-gray-900 border-transparent-500*/}
                <Link
                  to={ROUTES.HOMEPAGE}
                  className={`inline-flex items-center border-b-2 px-1 pt-1 text-sm font-medium  ${
                    location.pathname === ROUTES.HOMEPAGE
                      ? "border-indigo-500 text-gray-900 border-transparent-500"
                      : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                  }`}
                >
                  Home
                </Link>
                <Link
                  to="/admin-place"
                  className={`inline-flex items-center border-b-2 px-1 pt-1 text-sm font-medium  ${
                    location.pathname === ROUTES.ADMIN_PLACE
                      ? "border-indigo-500 text-gray-900 border-transparent-500"
                      : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                  }`}
                >
                  Food Places
                </Link>
                <Link
                  to="/admin-category"
                  className={`inline-flex items-center border-b-2 px-1 pt-1 text-sm font-medium  ${
                    location.pathname === ROUTES.ADMIN_CATEGORY
                      ? "border-indigo-500 text-gray-900 border-transparent-500"
                      : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                  }`}
                >
                  Food Categories
                </Link>
                <Link
                  to="/admin-location"
                  className={`inline-flex items-center border-b-2 px-1 pt-1 text-sm font-medium  ${
                    location.pathname === ROUTES.ADMIN_LOCATION
                      ? "border-indigo-500 text-gray-900 border-transparent-500"
                      : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                  }`}
                >
                  Locations
                </Link>
                <Link
                  to="/login"
                  className="inline-flex items-center border-b-2 border-transparent px-1 pt-1 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700"
                  onClick={onLogoutClick}
                >
                  Logout
                  <ArrowLeftOnRectangleIcon
                    className="h-6 w-6 text-gray-600 group-hover:text-indigo-600"
                    aria-hidden="true"
                  />
                </Link>
              </div>
              <div className="-mr-2 flex items-center md:hidden">
                {/* Mobile menu button */}
                <Disclosure.Button className="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                  <span className="absolute -inset-0.5" />
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
            </div>
          </div>

          <Disclosure.Panel className="md:hidden">
            <div className="space-y-1 pb-3 pt-2">
              {/* Current: "bg-indigo-50 border-indigo-500 text-indigo-700", Default: "border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700" */}
              {/* border-indigo-500 bg-indigo-50 text-indigo-700 */}
              <Disclosure.Button
                as="a"
                href="/"
                className={`block border-l-4 py-2 pl-3 pr-4 text-base font-medium ${
                  location.pathname === ROUTES.HOMEPAGE
                    ? "border-indigo-500 bg-indigo-50 text-indigo-700"
                    : "border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700"
                }`}
              >
                Home
              </Disclosure.Button>
              <Disclosure.Button
                as="a"
                href="admin-place"
                className={`block border-l-4 py-2 pl-3 pr-4 text-base font-medium ${
                  location.pathname === ROUTES.ADMIN_PLACE
                    ? "border-indigo-500 bg-indigo-50 text-indigo-700"
                    : "border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700"
                }`}
              >
                Food Places
              </Disclosure.Button>
              <Disclosure.Button
                as="a"
                href="admin-category"
                className={`block border-l-4 py-2 pl-3 pr-4 text-base font-medium ${
                  location.pathname === ROUTES.ADMIN_CATEGORY
                    ? "border-indigo-500 bg-indigo-50 text-indigo-700"
                    : "border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700"
                }`}
              >
                Food Categories
              </Disclosure.Button>
              <Disclosure.Button
                as="a"
                href="admin-location"
                className={`block border-l-4 py-2 pl-3 pr-4 text-base font-medium ${
                  location.pathname === ROUTES.ADMIN_LOCATION
                    ? "border-indigo-500 bg-indigo-50 text-indigo-700"
                    : "border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700"
                }`}
              >
                Location
              </Disclosure.Button>
              <div className="border-t border-gray-200 pb-2"></div>
              <Disclosure.Button
                as="button"
                onClick={onLogoutClick}
                className="block border-l-4 border-transparent py-2 pl-3 pr-4 text-base font-medium text-gray-500 hover:border-gray-300 hover:bg-gray-50 hover:text-gray-700"
              >
                <div className="flex justify-between">
                  Logout
                  <ArrowLeftOnRectangleIcon
                    className="h-6 w-6 text-gray-600 group-hover:text-indigo-600"
                    aria-hidden="true"
                  />
                </div>
              </Disclosure.Button>
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
};

export default Navigation;
